import React from 'react';
import { BookingButton } from '../components/BookingButton';
export function FreeResources() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-296">
      {/* SECTION 1 — HERO */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32 text-center" data-id="element-297">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-298"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-299"></div>
        <div className="max-w-[900px] mx-auto px-5 md:px-12 relative z-10" data-id="element-300">
          <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-301">
            Află unde e blocată afacerea ta
          </h1>
          <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10" data-id="element-302">
            Completează testul ProVi în 2 minute. Primești pe loc un scor pe
            fiecare din cele 8 componente ale afacerii tale și afli exact care e
            blocajul principal pe care trebuie să îl repari primul.
          </p>
          <BookingButton text="Fă Testul Gratuit — 2 Minute" href="#" className="px-10 py-5 text-[16px]" data-id="element-303" />
        </div>
      </section>

      {/* SECTION 2 — PROBLEMA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-304">
        <div className="max-w-[800px] mx-auto px-5 md:px-12 text-center" data-id="element-305">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8" data-id="element-306">
            Câte luni ai pierdut deja lucrând pe ce nu contează?
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8] text-left mb-12" data-id="element-307">
            <p data-id="element-308">
              Te trezești dimineața cu lista plină. Rezolvi urgențe, răspunzi la
              întrebări, stingi incendii. Ajungi seara epuizat și te întrebi ce
              ai construit de fapt azi. Mâine o iei de la capăt.
            </p>
            <p data-id="element-309">
              Fără o hartă clară a ce funcționează și ce nu în afacerea ta,
              fiecare zi de muncă e o loterie. Poate lucrezi pe ce trebuie.
              Poate nu. Nu ai de unde să știi. Și cu cât trece mai mult timp
              fără să identifici blocajul real, cu atât mai mult efort risipești
              pe simptome care revin lună după lună.
            </p>
            <p className="font-medium text-[#09111F] p-6 bg-[#F1F5F9] rounded-2xl border-l-4 border-[#1D4ED8]" data-id="element-310">
              Testul ProVi îți arată în 2 minute exact unde e problema. Nu pe
              baza a ce simți tu. Pe baza celor 8 componente care fac o afacere
              să funcționeze sau să se blocheze.
            </p>
          </div>
          <BookingButton text="Fă Testul Gratuit — 2 Minute" href="#" className="px-10 py-5 text-[16px]" data-id="element-311" />
        </div>
      </section>

      {/* SECTION 3 — TESTUL PROVI */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-312">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-313">
          <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] relative" data-id="element-314">
            <div className="absolute -top-5 inset-x-0 flex justify-center" data-id="element-315">
              <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase px-6 py-2 rounded-full shadow-md" data-id="element-316">
                DIAGNOSTIC GRATUIT
              </span>
            </div>
            <h2 className="font-['Montserrat'] text-[28px] md:text-[36px] font-bold text-[#09111F] mb-4 text-center mt-4" data-id="element-317">
              Testul ProVi: Cât de dependentă e afacerea ta de tine?
            </h2>
            <p className="font-['Inter'] text-[19px] text-[#6B7280] text-center mb-10 max-w-[700px] mx-auto" data-id="element-318">
              8 întrebări, una pentru fiecare componentă ProVi System. Răspunzi
              sincer, primești pe loc un scor care îți arată exact unde ești
              puternic și unde ai breșa cea mai mare.
            </p>

            <div className="mb-10" data-id="element-319">
              <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#1D4ED8] mb-6 border-b pb-2" data-id="element-320">
                Ce primești după test:
              </h3>
              <ul className="space-y-4" data-id="element-321">
                {['Scor individual pe fiecare din cele 8 componente: mentalitate, viziune, oameni, numere, procese, probleme, progres, cash', 'Identificarea blocajului principal care îți consumă cel mai mult timp, energie și bani chiar acum', 'Recomandare concretă: cu ce să începi, în funcție de scorul tău, fără jargon și fără teorie', 'Acces la rezultate pe email, cu explicația fiecărui scor și pașii următori pe care îi poți face singur', 'Posibilitatea de a programa un diagnostic gratuit de 30 de minute cu Valer pe baza rezultatelor tale'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-322">
                    <svg className="w-5 h-5 text-[#1D4ED8] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-323">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-324"></path>
                    </svg>
                    <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-325">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center" data-id="element-326">
              <BookingButton text="Începe Testul — Durează 2 Minute" href="#" className="px-10 py-5 text-[16px] w-full sm:w-auto mb-3" data-id="element-327" />
              <p className="font-['Inter'] text-[13px] text-[#6B7280]" data-id="element-328">
                Fără costuri. Fără obligații. Primești rezultatele pe loc.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 — CE SE SCHIMBĂ DUPĂ TEST */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-329">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-330">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-331">
            Ce afli după ce completezi testul
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-332">
            {[{
            title: 'Claritate reală',
            desc: 'Știi exact care componentă din afacerea ta te trage cel mai tare în jos, nu mai ghicești.'
          }, {
            title: 'Ordine în priorități',
            desc: 'Înțelegi cu ce să începi și ce poate aștepta, în loc să lucrezi pe toate deodată.'
          }, {
            title: 'Limbaj comun cu echipa',
            desc: 'Poți arăta echipei tale pe cifre unde e problema, în loc să le explici pe feeling.'
          }, {
            title: 'Primul pas concret',
            desc: 'Primești o recomandare clară pe care o poți aplica singur din ziua următoare.'
          }].map((benefit, i) => <div key={i} className="bg-[#F1F5F9] rounded-2xl p-6 border border-[rgba(0,0,0,0.04)] text-center" data-id="element-333">
                <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mb-4 text-[#1D4ED8] shadow-sm mx-auto" data-id="element-334">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-335">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-336"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[18px] font-bold text-[#09111F] mb-3" data-id="element-337">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-338">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 6 — CTA FINAL */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white text-center relative overflow-hidden" data-id="element-339">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-340"></div>
        <div className="max-w-[800px] mx-auto px-5 md:px-12 relative z-10" data-id="element-341">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-6" data-id="element-342">
            Vrei să mergem mai departe pe baza rezultatelor tale?
          </h2>
          <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] mb-10" data-id="element-343">
            Dacă după test vezi că scorul tău e scăzut pe 3 sau mai multe
            componente, e un semn clar că afacerea ta pierde bani și timp în
            fiecare lună. Programează un diagnostic gratuit de 30 de minute cu
            Valer și hai să vedem împreună care e planul concret pentru situația
            ta.
          </p>
          <BookingButton text="Programează Diagnosticul Gratuit cu Valer" className="px-10 py-5 text-[16px] mb-3" data-id="element-344" />
          <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.5)]" data-id="element-345">
            30 de minute. Fără costuri. Pleci cu o direcție clară.
          </p>
        </div>
      </section>
    </div>;
}